import { render, staticRenderFns } from "./OpendataForm.vue?vue&type=template&id=71cb24b2&"
import script from "./OpendataForm.vue?vue&type=script&lang=js&"
export * from "./OpendataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports